import type { UseHttp } from '~/api/interface'

export const fetchSendVerifyCode: UseHttp = (params, option) => {
  return useHttp.get(
    `/api/auth/sendRegisterVerifyCode/${params?.phone}/${params?.code}`,
    undefined,
    { ...option }
  )
}

export const fetchForget: UseHttp = (params, option) => {
  return useHttp.post('/api/auth/forget', params, { ...option })
}

export const fetchAuthLogin: UseHttp = (params, option) => {
  return useHttp.post('/api/auth/login', params, { ...option })
}

export const fetchAuthWxLogin: UseHttp = (params, option) => {
  return useHttp.get(`/api/auth/wxlogin/${params?.ticket}`, undefined, { ...option })
}

export const fetchGetWxQRScanCode: UseHttp = (params, option) => {
  return useHttp.get('/api/auth/getWxQRScanCode', undefined, { ...option })
}

export const fetchAuthLogout: UseHttp = (params, option) => {
  return useHttp.get('/api/auth/logout', undefined, { ...option })
}

export const fetchAuthLoginByCode: UseHttp = (params, option) => {
  return useHttp.get(`/api/auth/phonelr/${params?.phone}/${params?.code}`, undefined, { ...option })
}

export const fetchAuthBind: UseHttp = (params, option) => {
  return useHttp.post('/api/auth/bind', params, { ...option })
}

export const fetchGenerateCaptcha: UseHttp = (params, option) => {
  return useHttp.get('/api/captchaApi/generate', undefined, { ...option })
}

export const fetchVerifyCaptcha: UseHttp = (params, option) => {
  return useHttp.post(`/api/captchaApi/verify/${params?.code}`, undefined, { ...option })
}
